import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

function Charts() {
  const [state, setState] = useState({
    series: [
      {
        name: "Apple",
        data: [31, 40, 28, 51, 42, 109, 100],
      },
      {
        name: "Mango",
        data: [11, 32, 45, 32, 34, 52, 41],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "datetime",
        categories: [
          "2018-09-19T00:00:00.000Z",
          "2018-09-19T01:30:00.000Z",
          "2018-09-19T02:30:00.000Z",
          "2018-09-19T03:30:00.000Z",
          "2018-09-19T04:30:00.000Z",
          "2018-09-19T05:30:00.000Z",
          "2018-09-19T06:30:00.000Z",
        ],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
    },
  });

  return (
    <div>
      <h1>React Apex Chart</h1>
      <br />
      <br />
      <ReactApexChart
        options={state.options}
        series={state.series}
        // type="area"
        type="line"
        height={350}
        // width={500}
      />
    </div>
  );
}

export default Charts;
